import { MarketingCalendarListController } from './marketing-calendar-list.controller'

function marketingCalendarList () {
  return {
    restrict: 'E',
    scope: {
      tasks: '<',
      loading: '<',
      loadMoreTasks: '&',
      handleBackClick: '&'
    },
    templateUrl: '/workflow/directives/marketing-calendar-list/marketing-calendar-list.html?$$REVISION$$',
    controller: MarketingCalendarListController
  }
}

export { marketingCalendarList }
